import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ExternalSettings } from 'src/app/common/services/external-settings/external-settings.interface';
import { ExternalSettingsService } from 'src/app/common/services/external-settings/external-settings.service';
import { InternalSettingsService } from 'src/app/common/services/internal-settings/internal-settings.service';
import { UIUtilityService } from 'src/app/system/utility/ui-utility.service';
import { environment } from 'src/environments/environment';
import { InternalSettings } from '../../services/internal-settings/internal-settings.interface';
import { UserService } from '../../services/user/user.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.less'],
    standalone: false
})
export class HeaderComponent implements OnInit {

  public environment = environment;
  UIUtilityService: any = UIUtilityService;
  externalSettings!: ExternalSettings;
  internalSettings!: InternalSettings;

  src: string = '';
  menuType: string = "left";

  public externalLoaded : BehaviorSubject<boolean> = new BehaviorSubject(false);
  public internalLoaded : BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor(
    private router: Router,
    private srvES : ExternalSettingsService, 
    private srvIS : InternalSettingsService, 
    private srvUser : UserService) {
    }

  ngOnInit(): void {
    this.srvES.externalSettings$.subscribe((value) => {
      this.externalSettings = value;
      this.externalLoaded.next(true);
      this.menuType = value.globalVariables.customerWebMenuStyle;
      this.src = value.web.logo.image + '?lastmod' + value.web.logo.size;
    })
    
    this.srvIS.internalSettings$.subscribe((internalSettings) => {
      // console.log("Header Component: internalSettings has changed: " + internalSettings);
      
      if (internalSettings != null) {
        this.internalSettings = internalSettings!;
        this.internalLoaded.next(true);
      } else {
        this.internalLoaded.next(false);
      }
    })
  }

  public onLogoClick() {
    if (this.srvUser.isLoggedIn$.value) {

      // Route to Dashboard
      this.router.navigateByUrl("/dashboard");
    }
    else {
      this.srvUser.logoff();
    }
  }

  public onInfoClick() {
    let node = {
      "externalSettings": this.externalSettings,
      "internalSettings": this.internalSettings
    }
    navigator.clipboard.writeText(JSON.stringify(node, null, 2));
  }

  public getVersion() {
    let versionMatch = /\d+/.exec(window.document.location.pathname);
    let version = versionMatch ? versionMatch[0] : '2.0';
    return version;
  }

}


